import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

import type { ItemSummary } from '@/types/item/ItemSummary';

import { Catalog } from '@/types/Catalog';

import ReviewPageBody from './ReviewPageBody';
import ReviewPageHeader from './ReviewPageHeader';

type Props = {
    baseUrl: string;
    catalog: Catalog;
    disableSubmit: boolean;
    handleContinueClick: () => void;
    handleNotReceivedItemsClicked: () => void;
    handleNotTalkedToHouseClick: () => void;
    handleReceivedItemsClicked: () => void;
    handleTalkedToHouseClick: () => void;
    items: ItemSummary[];
    note: string;
    noteChange: (event: ChangeEvent<HTMLElement>) => void;
    noteValid: boolean;
    openSendSellerMessageModal: Function;
    ratingChangeAccuracy: Function;
    ratingChangeOverall: Function;
    ratingChangePayment: Function;
    ratingChangeResponsiveness: Function;
    ratingChangeShipping: Function;
    receivedItems: boolean;
    review: string;
    reviewChange: (event: ChangeEvent<HTMLElement>) => void;
    reviewError: boolean;
    reviewHeadlineChange: (event: ChangeEvent<HTMLElement>) => void;
    reviewHeadlineError: boolean;
    reviewSubmitted: boolean;
    reviewValid: boolean;
    selectedContinue: boolean;
    selectedRecievedItems: boolean;
    submitReview: () => void;
    talkedToHouse: boolean;
};

const ReviewPage = (props: Props) => {
    const {
        baseUrl,
        catalog,
        disableSubmit,
        handleContinueClick,
        handleNotReceivedItemsClicked,
        handleNotTalkedToHouseClick,
        handleReceivedItemsClicked,
        handleTalkedToHouseClick,
        items,
        note,
        noteChange,
        noteValid,
        openSendSellerMessageModal,
        ratingChangeAccuracy,
        ratingChangeOverall,
        ratingChangePayment,
        ratingChangeResponsiveness,
        ratingChangeShipping,
        receivedItems,
        review,
        reviewChange,
        reviewError,
        reviewHeadlineChange,
        reviewHeadlineError,
        reviewSubmitted,
        reviewValid,
        selectedContinue,
        selectedRecievedItems,
        submitReview,
        talkedToHouse,
    } = props;

    return (
        <Container>
            <ReviewPageHeader
                baseUrl={baseUrl}
                catalog={catalog}
                handleNotReceivedItemsClicked={handleNotReceivedItemsClicked}
                handleReceivedItemsClicked={handleReceivedItemsClicked}
                items={items}
                receivedItems={receivedItems}
                selectedRecievedItems={selectedRecievedItems}
            />
            <ReviewPageBody
                catalog={catalog}
                disableSubmit={disableSubmit}
                handleContinueClick={handleContinueClick}
                handleNotTalkedToHouseClick={handleNotTalkedToHouseClick}
                handleTalkedToHouseClick={handleTalkedToHouseClick}
                note={note}
                noteChange={noteChange}
                noteValid={noteValid}
                openSendSellerMessageModal={openSendSellerMessageModal}
                ratingChangeAccuracy={ratingChangeAccuracy}
                ratingChangeOverall={ratingChangeOverall}
                ratingChangePayment={ratingChangePayment}
                ratingChangeResponsiveness={ratingChangeResponsiveness}
                ratingChangeShipping={ratingChangeShipping}
                receivedItems={receivedItems}
                review={review}
                reviewChange={reviewChange}
                reviewError={reviewError}
                reviewHeadlineChange={reviewHeadlineChange}
                reviewHeadlineError={reviewHeadlineError}
                reviewSubmitted={reviewSubmitted}
                reviewValid={reviewValid}
                selectedContinue={selectedContinue}
                selectedRecievedItems={selectedRecievedItems}
                submitReview={submitReview}
                talkedToHouse={talkedToHouse}
            />
        </Container>
    );
};

export default ReviewPage;

const Container = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;
    padding: 0 20px 30px;
`;
